import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const testimonials = [
    {
      id: 1,
      text: 'Deniz Hanım ile yaptığım doğum haritası analizi hayatımda bir dönüm noktası oldu. Kendimi daha iyi anlamama ve doğru kararlar almama yardımcı oldu. Profesyonel yaklaşımı ve samimiyeti için çok teşekkür ederim.',
      initials: 'A.K.',
      role: 'Danışan',
    },
    {
      id: 2,
      text: 'Spiritüel danışmanlık seansları sayesinde içsel huzurumu buldum. Deniz Hanım\'ın rehberliği ve enerji çalışmaları gerçekten etkili. Kendimi çok daha güçlü ve dengeli hissediyorum.',
      initials: 'M.Y.',
      role: 'Danışan',
    },
    {
      id: 3,
      text: 'Yıllardır aradığım desteği Deniz Hanım\'da buldum. Astrolojik danışmanlık ve enerji şifa seansları hayatımı olumlu yönde değiştirdi. Herkese gönül rahatlığıyla tavsiye ediyorum.',
      initials: 'S.T.',
      role: 'Danışan',
    },
  ];

  return (
    <section className="py-24 bg-primary-dark">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Side - Header */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            {/* Decorative Quote */}
            <div className="text-[200px] leading-none text-gold/15 font-serif mb-4">
              "
            </div>

            <h2 className="font-serif text-4xl lg:text-5xl mb-6">
              <div className="text-white font-light">Danışanlarımızın</div>
              <div className="text-gold font-bold italic mt-2 bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent">
                Deneyimleri
              </div>
            </h2>

            <div className="flex items-center space-x-3 text-text-light">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-gold text-xl"></i>
                ))}
              </div>
              <span className="text-sm font-medium">500+ Mutlu Danışan</span>
            </div>
          </motion.div>

          {/* Right Side - Testimonials */}
          <div className="lg:col-span-3">
            <div className="space-y-6 max-h-[600px] overflow-y-auto pr-4 custom-scrollbar">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={testimonial.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white/5 border border-gold/20 rounded-2xl p-8 hover:bg-white/10 hover:border-gold/40 transition-all duration-300"
                >
                  {/* Stars */}
                  <div className="flex items-center space-x-1 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-gold text-base"></i>
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <p className="text-white leading-relaxed mb-6 text-base">
                    {testimonial.text}
                  </p>

                  {/* Author */}
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold to-gold-light flex items-center justify-center">
                      <span className="text-primary-dark font-bold text-sm">
                        {testimonial.initials}
                      </span>
                    </div>
                    <div>
                      <p className="text-white font-bold text-sm">{testimonial.initials}</p>
                      <p className="text-text-light text-xs">{testimonial.role}</p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(212, 175, 55, 0.1);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #D4AF37;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #F4E4C1;
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;